// extracted by mini-css-extract-plugin
export default {"body-1":"yp6CG2bdmAxXKeCHjC_A","body-2":"gaSuWwEhJa46LtbZw4XI","body-3":"TTSoBOPDmCUz6rDivOhL","ant-typography":"hwHxHxF2CFu4DUkcIhIj","text":"dzrnKJejJ3zTO5VXrE3f"};